import React, { useMemo } from 'react';

// Static, non-animated positioning so it doesn't re-render.
const StarfieldBg = ({ count = 60 }) => {
  const stars = useMemo(() => {
    const arr = [];
    for (let i = 0; i < count; i++) {
      const size = Math.random() * 2 + 1;
      arr.push({
        id: i,
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`,
        size: `${size}px`,
        delay: `${Math.random() * 3}s`,
        duration: `${2 + Math.random() * 3}s`
      });
    }
    return arr;
  }, [count]);

  return (
    <>
      <div className="starfield" aria-hidden="true">
        {stars.map((s) => (
          <div
            key={s.id}
            className="star"
            style={{
              top: s.top,
              left: s.left,
              width: s.size,
              height: s.size,
              animationDelay: s.delay,
              animationDuration: s.duration
            }}
          />
        ))}
      </div>
      <div className="aurora-orb aurora-orb-1" aria-hidden="true"></div>
      <div className="aurora-orb aurora-orb-2" aria-hidden="true"></div>
      <div className="aurora-orb aurora-orb-3" aria-hidden="true"></div>
    </>
  );
};

export default StarfieldBg;
